var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            {
              staticClass: "config-col",
              attrs: { lg: "4", sm: "12", xs: "12", "no-padding": "" },
            },
            [
              _c("app-stock-location-select", {
                on: {
                  input: function ($event) {
                    return _vm.emitStocks()
                  },
                },
                model: {
                  value: _vm.locationID,
                  callback: function ($$v) {
                    _vm.locationID = $$v
                  },
                  expression: "locationID",
                },
              }),
              _c("w-date-picker", {
                staticClass: "mts",
                attrs: {
                  label: _vm.$ct("date"),
                  "max-date": _vm.maxDate,
                  fancy: "",
                  "popover-visibility": "focus",
                },
                on: {
                  input: function ($event) {
                    return _vm.emitStocks()
                  },
                },
                model: {
                  value: _vm.dateCreated,
                  callback: function ($$v) {
                    _vm.dateCreated = $$v
                  },
                  expression: "dateCreated",
                },
              }),
              _c("w-input-number", {
                staticClass: "mts",
                attrs: {
                  label: _vm.$ct("buyPrice"),
                  decimals: _vm.DecimalSettings.Buy,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.emitStocks()
                  },
                },
                model: {
                  value: _vm.buyPrice,
                  callback: function ($$v) {
                    _vm.buyPrice = $$v
                  },
                  expression: "buyPrice",
                },
              }),
              _c("app-contact-search", {
                staticClass: "mts",
                attrs: {
                  "group-id": 2,
                  label: _vm.$ct("searchSupplier"),
                  value: _vm.supplier,
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.selectSupplier($event)
                  },
                },
              }),
            ],
            1
          ),
          _c("w-col", { attrs: { lg: "8", sm: "12" } }, [
            _c(
              "div",
              { staticClass: "size-rows-scroll" },
              [
                _c(
                  "app-custom-table",
                  { attrs: { cellpadding: "0", cellspacing: "0" } },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticStyle: { width: "60%" } }, [
                          _vm._v(_vm._s(_vm.$ct("size"))),
                        ]),
                        _c("th", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.$ct("qty"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.sizeEntries, function (entry, index) {
                        return _c("tr", { key: entry.ID }, [
                          _c("td", [_vm._v(_vm._s(entry.Name))]),
                          _c(
                            "td",
                            { staticClass: "amount" },
                            [
                              _c("w-input-number", {
                                ref: "qtyInputs",
                                refInFor: true,
                                attrs: { decimals: 0 },
                                on: {
                                  input: function ($event) {
                                    return _vm.emitStocks()
                                  },
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.focusNext(index)
                                  },
                                },
                                model: {
                                  value: _vm.qtyByEntry[entry.ID],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.qtyByEntry, entry.ID, $$v)
                                  },
                                  expression: "qtyByEntry[entry.ID]",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "size-total" }, [
              _c("span", { staticClass: "size-total-label" }, [
                _vm._v(_vm._s(_vm.$ct("totalBooked"))),
              ]),
              _c("div", { staticClass: "size-total-value" }, [
                _vm._v(_vm._s(_vm.totalQty)),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }